import XButton from "../common/XButton";

const GetHelpButton = ({ onClick, variant = "secondary", className }) => (
  <XButton variant={variant} className={className} onClick={onClick}>
    <span>Get Help</span>
  </XButton>
);

export default GetHelpButton;
